import React from 'react';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const WHATSAPP_URL = 'https://wa.me/919902506684?text=Hi%2C%20I%20want%20to%20place%20a%20grocery%20order';

export default function Hero() {
  return (
    <section className="relative pt-32 pb-24 md:pt-44 md:pb-40 overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1920&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1B4332]/95 via-[#2D6A4F]/90 to-[#40916C]/85"></div>
      </div>

      <div className="content-width relative z-10">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="font-heading text-4xl md:text-6xl font-extrabold leading-[1.1] tracking-tight text-white"
        >
          Your Monthly Groceries<br />
          Without The{' '}
          <span className="relative inline-block">
            Monthly Chaos
            <span className="absolute bottom-1 left-0 w-full h-3 bg-white/25 -z-10 rounded-sm"></span>
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="mt-6 text-lg md:text-xl text-white/85 max-w-lg leading-relaxed"
        >
          One Click Essentials manages your entire grocery procurement — from planning to delivery — so you can focus on what matters.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-primary font-semibold px-7 py-3.5 rounded-lg text-base hover:bg-secondary hover:scale-[1.02] transition-all flex items-center gap-2 shadow-lg"
          >
            <MessageCircle className="h-4 w-4" />
            Order on WhatsApp
          </a>
          <a
            href="#how-it-works"
            className="text-white font-medium text-base flex items-center gap-1 hover:gap-2 transition-all"
          >
            How It Works <ArrowRight className="h-4 w-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
